<template>
    <div class="list-group-item vehicle-type-box">
        <div class="row d-flex justify-content-between align-items-center mx-0" @click="visible = !visible" role=button>
            <p class="mb-0"><b>{{$t('cat.filter.vehicle.type')}}</b></p>
            <component v-bind:is="getChevronTag" />
        </div>

        <b-collapse :visible="visible">
            <filter-checkbox-box
                filter-title="category"
            ></filter-checkbox-box>
        </b-collapse>
    </div>
</template>

<script>
import FilterCheckboxBox from "./FilterCheckboxBox.vue";
import { BCollapse, BIconChevronUp, BIconChevronDown } from "bootstrap-vue";

export default {
    name: 'FilterVehicleTypeBox',
    components: {
        FilterCheckboxBox,
        BCollapse, BIconChevronUp, BIconChevronDown
    },
    data() {
        return {
            visible: false,
        }
    },
    computed: {
        getChevronTag() {
            return this.visible ? "b-icon-chevron-up" : "b-icon-chevron-down";
        },
    },
    methods: {
        initVisibleState() {
            if (this.$route.query.category) {
                this.visible = true
            }
        }
    },
    mounted() {
        this.initVisibleState()
    }
}
</script>
